import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';

export function useGetUserExistGq(
  command: CommandGq
) {
  const query = useCustomQuery<ResponseGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network'
  });

  return {
    query,
    result: query.data?.users?.getUserExist?.alreadyInvited,
  };
}

const gqTag = gql`
  query GetUserExistGq($command: GetUserExistCommand!) {
    users {
      getUserExist(command: $command) {
        alreadyInvited
      }
    }
  }
`;

export interface ResponseGq {
  users: {
    getUserExist: {
      alreadyInvited: boolean;
    };
  };
}

export interface VariablesGq {
  command: CommandGq;
}



export interface CommandGq {
  email: string;
}

export interface GetUserExistsVariablesGq extends VariablesGq { }
export interface GetUserExistsResponseGq extends ResponseGq { }
export const getUserExistsGqTag = gqTag;